import { Badge, badgeClasses, Chip, CircularProgress } from '@mui/material';
import { size } from 'lodash';

import { useGetAllBookingScheduleWaitingConfirmQuery } from 'src/api/booking-schedule-api';

const MenuSchedulTitle = ({ title, count, isLoading }) => {
  return (
    <Badge
      badgeContent={
        isLoading ? (
          <CircularProgress
            size={10}
            sx={{
              color: '#fff' // Màu trắng
            }}
          /> // Kích thước nhỏ của spinner
        ) : (
          count // Hiển thị số đếm khi không loading
        )
      }
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
      sx={{
        [`& .${badgeClasses.badge}`]: {
          top: -2,
          right: -8
        }
      }}
      color="info"
    >
      {title}
    </Badge>
  );
};

export const MenuScheduleCountWaitingConfirm = ({ count, isLoading }) => {
  if (isLoading) {
    return <CircularProgress size={20} />;
  }
  return (
    // <Box component="span" sx={{ ml: 2, bgcolor: 'error.main' }}>
    <Chip label={count} size="small" color="info" />
    // </Box>
  );
};

const MenuSchedule = ({ title }) => {
  const { data, isLoading, isSuccess } = useGetAllBookingScheduleWaitingConfirmQuery();

  const count = isSuccess ? size(data) : 0;

  if (title) {
    return <MenuSchedulTitle title={title} count={count} isLoading={isLoading} />;
  }

  return <MenuScheduleCountWaitingConfirm count={count} isLoading={isLoading} />;
};

export default MenuSchedule;
